import request from '@/utils/request'

export function apiGetForms(form_id) {
  return request({
    url: form_id ? '/forms.json?form_id=' + form_id : '/forms.json',
    method: 'get',
  })
}
